import React, { useRef, useState, useEffect } from "react";
import { HistoryProps, TooltipTextProps } from "./interface";

// export const TooltipText = ({ text }: TooltipTextProps) => {
//   const textRef = useRef<HTMLDivElement>(null);
//   const [isTruncated, setIsTruncated] = useState(false);

//   useEffect(() => {
//     const { current } = textRef;
//     if (current) {
//       setIsTruncated(current.scrollWidth > current.clientWidth);
//     }
//   }, [text]);

//   return (
//     <div className="relative group w-64">
//       <div
//         ref={textRef}
//         className="truncate w-full"
//         style={{ whiteSpace: "nowrap" }}
//       >
//         {text}
//       </div>
//       {isTruncated && (
//         <div className="absolute ml-64 top-[1px] bottom-full mb-1 hidden w-max max-w-xs bg-gray-700 text-white text-sm p-2 rounded-md group-hover:block">
//           {text}
//         </div>
//       )}
//     </div>
//   );
// };

export default function ToolTipButtons({
  conversation,
  historyID,
  handleHistoryID,
}: TooltipTextProps) {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const { current } = textRef;
    if (current) {
      setIsTruncated(current.scrollWidth > current.clientWidth);
    }
  }, [conversation.conversation_title]);

  // Function to get the background color
  const getBackgroundColor = (index: number | string) => {
    return historyID === index ? "#7F26D3" : "white";
  };

  // Function to get the text color
  const getTextColor = (index: number | string) => {
    return historyID === index ? "white" : "black";
  };

  // return (
  //   <div className="relative group bg-red-400">
  //     <div
  //       ref={textRef}
  //       className="truncate text-black"
  //       style={{ whiteSpace: "nowrap" }}
  //     >
  //       {text}
  //     </div>
  //     {isTruncated && (
  //       <div className="absolute z-[10000] text-black ml-64 top-[1px] bottom-full mb-1 hidden w-max max-w-xs bg-gray-700 text-white text-sm p-2 rounded-md group-hover:block">
  //         {text}
  //       </div>
  //     )}
  //   </div>
  // );
  return (
    <button
      key={conversation.conversation_id}
      onClick={() => {
        handleHistoryID(conversation.conversation_id);
      }}
      className={`-mx-3 mr-3 text-left bg-${getBackgroundColor(
        conversation.conversation_id
      )} h-[36px] w-full block px-4 py-1 text-base font-semibold leading-7 text-gray-900 hover:bg-[#7F26D3] hover:text-white`}
      style={{
        backgroundColor: getBackgroundColor(conversation.conversation_id),
        color: getTextColor(conversation.conversation_id),
      }}
    >
      {/* {setTitle(item.conversation_title)} */}
      {/* <TempApp text={item.conversation_title} /> */}
      <div className="truncate group " ref={textRef}>
        {conversation.conversation_title}
        {isTruncated && (
          <div className="ml-[18vw] -mt-[10vh] absolute hidden bg-[#2e2b2e] z-[20000] text-white text-wrap w-80  text-sm p-2 rounded-md group-hover:block">
            {conversation.conversation_title}
          </div>
        )}
      </div>
    </button>
  );
}
